import React from 'react';

import ChartReport from 'components/charts/Chart';
import { COMPARE_CHART } from 'constants/charts';

const genderFilters = [
  { name: 'Male' },
  { name: 'Female' },
  { name: 'Unresponded' },
];

const GenderComparisionReport = ({ questionId, startDate, endDate }) => {
  return (
    <div className="p-3 d-flex" style={{ overflowX: 'scroll' }}>
      <ChartReport
        titleText="How did each gender answer the question?"
        subtitleText="Compared to average participants"
        chartType="column"
        dataType="comparison"
        category="gender"
        filterType="gender"
        axisTitle="Percentage of respondants"
        percentage
        colors={COMPARE_CHART}
        filters={genderFilters}
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
        containerClassName="w-100"
      />
    </div>
  );
};

export default GenderComparisionReport;



// WEBPACK FOOTER //
// ./src/components/advancedReport/genderComparisionReport.js